export const text = {     
    baseStyle: {
        color: 'gray.600',
        fontWeight: '400',
    },  
    variants:{
        "link":{                        
            color: 'brand.600',  
            fontSize: "16px",
            _hover:{
                color: 'brand.700'
            }       
        },
        "gray":{
            color: 'gray.600'
        },
        "dim":{
            color: 'gray.400'
        }
    },
    sizes: {
        "sm":{
            fontSize: "15px"
        }
    }
}